import { useEffect, useMemo, useState } from "react";

type Timer = {
  minutes: number;
  seconds: number;
};

export const useCountdown = (countdownMinutes: number) => {
  const [_timer, setTimer] = useState<Timer>({
    minutes: countdownMinutes,
    seconds: 0,
  });
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout>();

  const handleCountdown = (prevTimer: Timer) => {
    if (prevTimer?.seconds > 0) {
      return { ...prevTimer, seconds: prevTimer.seconds - 1 };
    } else {
      if (prevTimer?.minutes > 0) {
        return {
          minutes: prevTimer.minutes - 1,
          seconds: 59,
        };
      }
    }
  };

  const stopCountdown = () => {
    intervalId && clearInterval(intervalId);
    setIntervalId(undefined);
  };

  useEffect(() => {
    if (!intervalId) {
      setIntervalId(setInterval(() => setTimer((prevState) => handleCountdown(prevState)), 1000));
    }
    return () => stopCountdown();
  }, []);

  useEffect(() => {
    if (intervalId && _timer && _timer?.minutes === 0 && _timer?.seconds === 0) {
      stopCountdown();
    }
  }, [_timer]);

  const cipherToString = (cipher: number) => {
    return cipher.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  };

  const timer = useMemo(
    () =>
      `${cipherToString((_timer && _timer?.minutes) || 0)}:${cipherToString(
        (_timer && _timer?.seconds) || 0
      )}`,
    [_timer]
  );

  return { timer };
};
